// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2R52l","dragIcon":"SortableItem_dragIcon__3q16z","disabled":"SortableItem_disabled__3qUPS"};